import React, { memo } from 'react';
import Styles from './auth-footer-styles.scss';
import { APP_VERSION } from '@/presentation/constants/app-version';
const Footer = ({ leftInner = true }) => {
    if (leftInner) {
        return (React.createElement("footer", { className: Styles.footer },
            React.createElement("div", { className: Styles.item },
                React.createElement("span", null,
                    "Copyright \u00A9 ",
                    new Date().getFullYear(),
                    " KidVestors, Inc. All Rights Reserved")),
            React.createElement("div", { className: Styles.footerSubSection },
                React.createElement("div", { className: Styles.link },
                    React.createElement("a", { href: "https://www.kidvestors.co/legal", target: "_blank", rel: "noopener noreferrer" }, "Terms & Conditions")),
                React.createElement("div", { className: Styles.link },
                    React.createElement("a", { href: "https://www.kidvestors.co/privacypolicy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy"))),
            React.createElement("div", { style: { fontSize: 8, color: 'gray' } }, `${process.env.REACT_APP_STAGE || ''} - V. ${APP_VERSION}`)));
    }
    return (React.createElement("footer", { className: Styles.footerSpace },
        React.createElement("div", { className: Styles.left },
            React.createElement("span", null,
                "Copyright \u00A9 ",
                new Date().getFullYear(),
                " KidVestors, Inc. All Rights Reserved")),
        React.createElement("div", { className: Styles.right },
            React.createElement("div", { className: Styles.link },
                React.createElement("a", { href: "https://www.kidvestors.co/legal", target: "_blank", rel: "noopener noreferrer" }, "Terms & Conditions")),
            React.createElement("div", { className: Styles.link },
                React.createElement("a", { href: "https://www.kidvestors.co/privacypolicy", target: "_blank", rel: "noopener noreferrer" }, "Privacy Policy")))));
};
export default memo(Footer);
